export const highLightText = (text, searchRegExp) => {
  return text.replace(
    searchRegExp,
    search =>
      '<span style="background-color:#fce1cc; font-weight:bold">' +
      search +
      '</span>'
  )
}
